import { PAGE_CONSTANT } from '@constants/page';

export type SpcType = keyof typeof PAGE_CONSTANT.SPC.GA4_PAGE_NAME;

export type SpcGa4PageName = (typeof PAGE_CONSTANT.SPC.GA4_PAGE_NAME)[SpcType];

const SPC_NAVIGATION_HEADER_TITLE = 'W DESIGNERS';

/**
 * spcType 코드를 GA4 page 명으로 변환합니다.
 *
 * @example
 * getSpcGa4PageName('SPC001') // 'W NEXT'
 * getSpcGa4PageName('spc003') // '하이퍼그라운드'
 */
export const getSpcGa4PageName = (spcType: string): string => {
  const normalizedType = spcType.toUpperCase() as SpcType;

  return PAGE_CONSTANT.SPC.GA4_PAGE_NAME[normalizedType] ?? '';
};

/**
 * spcType 코드를 헤더 타이틀로 변환합니다.
 * 네비게이션 대상 타입(SPC001, SPC002)은 네비게이션 조회 전에는 빈 값을 반환하고,
 * 조회 후 네비게이션이 있으면 'W DESIGNERS', 없으면 GA4 page 명을 반환합니다.
 *
 * @example
 * getSpcHeaderTitle('SPC001', false, false) // ''
 * getSpcHeaderTitle('SPC001', true, true) // 'W DESIGNERS'
 * getSpcHeaderTitle('SPC001', false, true) // 'W NEXT'
 * getSpcHeaderTitle('spc003') // 'HYPERGROUND'
 */
export const getSpcHeaderTitle = (
  spcType: string,
  hasNavigation = false,
  isNavigationResolved = true
): string => {
  const normalizedType = spcType.toUpperCase() as SpcType;

  const isNavigationSpcType = PAGE_CONSTANT.SPC.NAVIGATION_SPC_TYPES.some(
    type => type === normalizedType
  );

  if (isNavigationSpcType && !isNavigationResolved) {
    return '';
  }

  if (isNavigationSpcType && hasNavigation) {
    return SPC_NAVIGATION_HEADER_TITLE;
  }

  return PAGE_CONSTANT.SPC.GA4_PAGE_NAME[normalizedType] ?? '';
};

export const getTextColorType = (textColorCd: string) => {
  if (textColorCd === '#FFFFFF') return 'white';
  if (textColorCd === '#000000') return 'black';
  return 'white';
};
